module.exports = __webpack_public_path__ + "static/ray-of-frost-mtg_afr-b2c6fef92ef97a79fc7ee0ddb01ba025.jpg";